module.exports = __webpack_public_path__ + "img/Introduction.d8ea3f58.gif";